import { render, staticRenderFns } from "./ChatAxerta.vue?vue&type=template&id=c8ca4b38&"
import script from "./ChatAxerta.vue?vue&type=script&lang=js&"
export * from "./ChatAxerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports